if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');
			this.productGallery?.addEventListener('keydown', event => {
				if (event.key === ' ' && event.target.matches('.css-slider-button')) {
					event.preventDefault();
					event.target.click();
				}
			});

			// Gallery thumbnails

			if ( this.productSlider ) {

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				if ( this.productGallery.dataset.jsDisableParallax == 'false' ) {
					this.productSlider.addEventListener('ready', (e)=>{
						
						if ( this.firstProductGalleryIndex ) {
							this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
						}

						const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
						const productFigures = this.querySelectorAll('.apply-gallery-animation');
						this.productSlider.addEventListener('scroll', ()=>{
							const scrollX = -this.productSlider.element.scrollLeft;
							productSlides.forEach((slide,i)=>{
								const media = productFigures[i];
								if ( media ) {
									media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
								}
							});
						});

					});
				}

			}

			this.querySelector('[data-js-product-form]')?.addEventListener('add-to-cart', () => {
				document.getElementById('cart-recommendations')?.generateRecommendations();
			});

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}
		}

		thumbnailNavigationHelper(index=0){
			let selected;
			const thumbnails = Array.from(this.querySelectorAll('.product-gallery__thumbnails .thumbnail'));
			thumbnails.forEach((elm, i)=>{
				elm.setAttribute('aria-current', String(i == index));
				if ( i == index ) {
					elm.classList.add('active');
						selected = elm;
				} else {
					elm.classList.remove('active');
				}
			});
			const holder = this.querySelector('.product-gallery__thumbnails-holder');
			if (!holder || !selected) return;
			const vertical = getComputedStyle(holder).flexDirection === 'column';
			const start = vertical ? selected.offsetTop : selected.offsetLeft;
			const size = vertical ? selected.offsetHeight : selected.offsetWidth;
			const viewport = vertical ? holder.clientHeight : holder.clientWidth;
			const current = vertical ? holder.scrollTop : holder.scrollLeft;
			const previous = thumbnails[Number(index) - 1] || selected;
			const next = thumbnails[Math.min(Number(index) + 2, thumbnails.length - 1)];
			let visibleStart = vertical ? previous.offsetTop : previous.offsetLeft;
			let visibleEnd = vertical ? next.offsetTop + next.offsetHeight : next.offsetLeft + next.offsetWidth;
			// Reveal two following thumbnails when the rail has room.
			if (visibleEnd - visibleStart > viewport) visibleStart = start;
			if (visibleEnd - visibleStart > viewport) {
				const immediateNext = thumbnails[Number(index) + 1] || selected;
				visibleEnd = vertical ? immediateNext.offsetTop + immediateNext.offsetHeight : immediateNext.offsetLeft + immediateNext.offsetWidth;
			}
			if (visibleEnd - visibleStart > viewport) visibleEnd = start + size;
			let target = current;
			if (visibleEnd > current + viewport) target = visibleEnd - viewport;
			if (visibleStart < target) target = visibleStart;
			if (Math.abs(target - current) > 1) {
				holder.scrollTo({
					[vertical ? 'top' : 'left']: Math.max(0, target),
					behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
				});
			}
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

			}
		}
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}

